import React from "react";
import { X } from "lucide-react";

/** Sticky header for the owner user drawer. */
export default function DrawerHeader({ user, onClose }) {
  return (
    <div
      className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b-2"
      style={{ backgroundColor: "#0B1E3F", borderBottomColor: "rgba(249,215,28,0.4)" }}
    >
      <div className="min-w-0">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em]" style={{ color: "#F9D71C" }}>
          Manage User
        </div>
        <div className="font-heading text-xl truncate">{user.name || "—"}</div>
        <div className="text-xs text-white/60 font-mono truncate">{user.email}</div>
      </div>
      <button
        data-testid="user-drawer-close"
        onClick={onClose}
        className="h-10 w-10 inline-flex items-center justify-center border-2 hover:bg-safety-yellow hover:text-black hover:border-safety-yellow transition-colors"
        style={{ borderColor: "#F9D71C" }}
        aria-label="Close"
      >
        <X className="w-5 h-5" strokeWidth={3} />
      </button>
    </div>
  );
}
